import { createPinia } from 'pinia';
import type { App } from 'vue';

import { PiniaColada } from '@pinia/colada';

import { createTanstackQuery } from '@/lib/tanstack-query/createTanstackQuery';
import { createToast } from '@/lib/toast-notification/createToast';
import { createRouter } from '@/router/createRouter';

export function setupRouter(app: App<unknown>) {
  const ROUTER_PREFIX = 'panel';

  if (!location.pathname.startsWith(`/${ROUTER_PREFIX}/`)) {
    history.replaceState(history.state, '', `/${ROUTER_PREFIX}${location.search}${location.hash}`);
  }

  app.use(createRouter(ROUTER_PREFIX));
}

export function setupStores(app: App<unknown>) {
  app.use(createPinia());

  app.use(PiniaColada);

  app.use(...createTanstackQuery());
}

export function setupApp(app: App<unknown>) {
  setupRouter(app);

  setupStores(app);

  app.use(...createToast());
}
